import isEmpty from "lodash/isEmpty";
import { Component } from "react";
import { connect } from "react-redux";
import { marketPeriodHelper } from "../../../../../../../../../helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventType,
} from "../../../../../../../../../types/eventType";
import BlankMarketRunnerDetails from "./components/BlankMarketRunnerDetails/BlankMarketRunnerDetails";
import "./MarketRunnerDetails.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
}; //

class MarketRunnerDetails extends Component<Props> {
  render() {
    const { event, market, marketType } = this.props;

    if (!isEmpty(market.runners)) {
      const type = marketPeriodHelper.getMarketTypeType(marketType);
      const component = marketPeriodHelper.getMarketTypeRunnerComponent(
        type,
        marketType,
        market,
        event
      );
      return component;
    }

    return <BlankMarketRunnerDetails />;
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(null, mapDispatchToProps)(MarketRunnerDetails) as any;
